import React from 'react'
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import FBCAnalytics from '../firebase/FBCAnalytics';
import { projectFirestore } from '../firebase/config';
import Ring from '../loadingIndicator/indicator';
import { QuestionsGridLayout } from '../pages/pageElements';

        const imageRef = projectFirestore.collection('questions')
        .orderBy('timestamp','desc');


        const QuestionsGrid = () =>  {
        
            const [docs, setDocs] = useState([]);
            const [lastDoc, setLastDoc] = useState();
            const [loading, setLoading] = useState(false);
            const [isEmpty, setIsEmpty] = useState(false);
        
        
            useEffect(() => {
                imageRef
                .limit(9)
                .get()
                .then((collections) =>{
        
                  const isCollectionEmpty = collections.size === 0;
                  if(!isCollectionEmpty){
        
                  const images = collections.docs.map((image) => image.data())
                  setDocs(images);
                  const lastDoc = collections.docs[collections.docs.length - 1];
                  setLastDoc(lastDoc);
                  
                  }else{
                    setIsEmpty(true)
                  }
                  setLoading(false);
                  
                })
            }, []);
        
            if(docs.length === 0){
                return <Ring/>;
               }
             
               
               const fetchMore =()=>{
                 setLoading(true);
                 imageRef
                 .startAfter(lastDoc)
                 .limit(9)
                 .get()
                 .then((collections) =>{
                   const isCollectionEmpty = collections.size === 0;
             
                   if(!isCollectionEmpty){
             
                     const images = collections.docs.map((image) => image.data())
                     setDocs(docs =>[...docs,...images])
                     const lastDoc = collections.docs[collections.docs.length - 1];
                     setLastDoc(lastDoc);
                    
                   }else{
                     setIsEmpty(true)
                   }
             
                    setLoading(false);
                 });
                 
               }
             
        
        
            return (
                <div>

                <QuestionsGridLayout>
                    {docs.map((doc,index) =>{
                    return(
                        <div className='question-wrap' key={index} 
                            layout
                            initial={{opacity:0}}
                            animate={{opacity:1}}
                            transition={{delay:1}}
                        >
                            <h1 className='qustion-text'>{doc.question}</h1>
                            <h2 className='answer-text'>{doc.answer}</h2>
                        </div>
                    )
        
                 })}
        
                </QuestionsGridLayout>
        
        
                {loading && <Ring/>}
        
        
                    {!loading && 
                    <div class="load-more">
                        {!isEmpty && 
                            <button class="more-button" onClick={fetchMore}>
                            SEE MORE
                            </button>
                        } 
                    </div>
                    }
        
                    {isEmpty &&
                    <div className='isEmpty'>
                        <p>Umm, looks like that's it 🤷🏿‍♂️</p>
                    </div>
                    }
        
                </div>
            )
        }
        
        export default QuestionsGrid;
        